import {useMemo} from 'react';
import {IProductShort} from 'modules/products/types';
import {getTopSection} from 'modules/product-snippet/components/ProductSnippetContainer/helpers';
import {IProductSnippet} from 'shared/types/productSnippet.types';

export const useProductStickers = (
    product: Pick<IProductShort, 'properties' | 'sections'>,
): IProductSnippet['stickers'] => {
    const {properties, sections} = product;
    const topSection = useMemo(() => getTopSection(sections), [sections]);

    return useMemo(() => {
        return properties?.reduce<IProductSnippet['stickers']>((previousValue, currentValue) => {
            if (
                'alcohol' === currentValue.code &&
                0 === Number(currentValue.value) &&
                ['vino', 'shampanskoe_i_igristoe_vino'].includes(topSection)
            ) {
                previousValue.push({
                    code: 'alcohol',
                    text: '0%',
                    tooltip: null,
                    iconName: null,
                });
                return previousValue;
            }

            if (
                'cultivationType' === currentValue.code &&
                'object' === typeof currentValue.value &&
                'value' in currentValue.value &&
                currentValue.value.value
            ) {
                previousValue.push({
                    code: 'cultivationType',
                    text: currentValue.value.value,
                    tooltip: currentValue.value.value,
                    iconName: 'organic',
                });
                return previousValue;
            }

            return previousValue;
        }, []);
    }, [properties, topSection]);
};
